// @i18n-ignore-file
import { IStatsigExperiment } from '@src/experiments/experiments.types'

export enum STATSIG_EXPERIMENTS {
  CTL_A_VS_A_EXPERIMENT = 'ctla-v-a',
  BANNER_A_CLP_A_V_A_EXPERIMENT = 'banner-a-clp-a-v-clp-a',
  EXPRESS_CHECKOUT_IN_CART = 'express-checkout-in-cart',
  SECOND_RETURNS_CHARGING = 'second-returns-charging',
  BUY_NOW_BUTTON_PDP = 'buy-now-button-pdp',
  CONTACT_US_LINK_EXPERIMENT = 'contact-us-link',
  TRACKING_PAGE_CONTACT_US = 'tracking-page-contact-us',
  CLP_SORT = 'clp_sorting_a_vs_b_vs_c',
  CLP_SORT_V2 = 'clpv2_with_iss',
  TESTING_A_A_A = 'testing_a_a_a_exp',
  EDD = 'edd',
  TRUSTARC_CCM = 'trusarc-ccm',
  URGENCY_TAGS = 'urgency-tags',
  ORDER_DETAILS = 'ecom-featurerollout-web-orders-revamp',
  NEW_MOBILE_NAV = 'mweb_nav_design',
  SAVE_PARTIAL_CHECKOUT = 'save-partial-checkout',
  NEW_CLP_FILTERS_DWEB = 'new-clp-filters-dweb',
  NEW_CLP_FILTERS_MWEB = 'new-clp-filters-mweb',
  EXCHANGE_FOR_ANYTHING = 'exchange-for-anything',
  NEW_SEARCH_SUGGESTIONS = 'new_search_suggestions',
  PERSONALISED_EXPLORE_EVERYTHING = 'personalized-explore-everything',
  FEATURE_SECTION_2_DESIGN = 'feature-section-2-design',
  CLP_PERSONALIZED = 'clp-personalized',
  PDP_VIDEO = 'pdp-video',
  PDP_TAG_VISIBILITY = 'pdp-tag-visibility',
  OOS_CART = 'out-of-stock-cart',
  PERSONALIZED_BESTSELLER = 'personalized_best_seller_v3',
  RECOMMENDED_FOR_YOU_CAROUSEL = 'recommended-for-you-carousel',
  CART_CHECKOUT_CTA_BUTTON = 'cart_checkout_cta_button',
  RETURN_POLICY_MESSAGING = 'return-policy-messaging',
  PICKED_FOR_YOU_V1 = 'picked-for-you_v1',
  GET_WEBSITE_PRODUCTS_MIGRATION = 'get-website-products-migration',
  MOBILE_CART_PAGE_EXPERIMENT = 'mobile-cart-page',
}

export enum STATSIG_EXPERIMENTS_BUCKETS {
  CONTROL = 'control',
  SHOW = 'show',
  GROUP_A = 'groupA',
  GROUP_B = 'groupB',
  GROUP_C = 'groupC',
  GROUP_D = 'groupD',
}
export const STATSIG_NO_FALLBACK_EXPERIMENTS = new Set<STATSIG_EXPERIMENTS>([
  STATSIG_EXPERIMENTS.PERSONALIZED_BESTSELLER,
])
export const STATSIG_EXPERIMENTS_CONFIG: Record<STATSIG_EXPERIMENTS, IStatsigExperiment> = {
  [STATSIG_EXPERIMENTS.RETURN_POLICY_MESSAGING]: {
    experimentName: 'return-policy-messaging',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
  },
  [STATSIG_EXPERIMENTS.EXCHANGE_FOR_ANYTHING]: {
    experimentName: 'exchange-for-anything',
    buckets: {
      show: 'Show',
      control: 'Control',
    },
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.BUY_NOW_BUTTON_PDP]: {
    experimentName: 'buy-now-button-pdp',
    defaultBucket: 'Control', // Show, Control
  },
  [STATSIG_EXPERIMENTS.CTL_A_VS_A_EXPERIMENT]: {
    experimentName: 'ctla-v-a',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.BANNER_A_CLP_A_V_A_EXPERIMENT]: {
    experimentName: 'banner-a-clp-a-v-clp-a',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.SECOND_RETURNS_CHARGING]: {
    experimentName: 'second-returns-charging',
    defaultBucket: 'Control',
  },
  [STATSIG_EXPERIMENTS.EXPRESS_CHECKOUT_IN_CART]: {
    experimentName: 'express-checkout-in-cart',
    defaultBucket: 'control',
    buckets: {
      testA: 'testA',
      testB: 'testB',
      control: 'control',
    },
  },
  [STATSIG_EXPERIMENTS.CONTACT_US_LINK_EXPERIMENT]: {
    experimentName: 'contact-us-link',
    defaultBucket: 'Control',
    buckets: {
      show: 'Show',
      control: 'Control',
    },
  },
  [STATSIG_EXPERIMENTS.CLP_SORT]: {
    experimentName: 'clp_sorting_a_vs_b_vs_c',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.CLP_SORT_V2]: {
    experimentName: 'clpv2_with_iss',
    buckets: {
      control: 'control',
      groupA: 'groupA',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.PDP_TAG_VISIBILITY]: {
    experimentName: 'pdp-tag-visibility',
    buckets: {
      control: 'control',
      groupA: 'groupA',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.TESTING_A_A_A]: {
    experimentName: 'testing_a_a_a_exp',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.EDD]: {
    experimentName: 'edd',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
  },
  [STATSIG_EXPERIMENTS.TRUSTARC_CCM]: {
    experimentName: 'trusarc-ccm',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.URGENCY_TAGS]: {
    experimentName: 'urgency-tags',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
  },
  [STATSIG_EXPERIMENTS.ORDER_DETAILS]: {
    experimentName: STATSIG_EXPERIMENTS.ORDER_DETAILS,
    defaultBucket: 'Control',
    buckets: {
      show: 'Show',
      control: 'Control',
    },
  },
  [STATSIG_EXPERIMENTS.NEW_MOBILE_NAV]: {
    experimentName: 'mweb_nav_design',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
    defaultBucket: 'control',
  },
  [STATSIG_EXPERIMENTS.SAVE_PARTIAL_CHECKOUT]: {
    experimentName: 'save-partial-checkout',
    defaultBucket: 'Control',
    buckets: {
      Control: 'Control',
      Test: 'Test',
    },
  },
  [STATSIG_EXPERIMENTS.NEW_CLP_FILTERS_DWEB]: {
    experimentName: 'new-clp-filters-dweb',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
      groupC: STATSIG_EXPERIMENTS_BUCKETS.GROUP_C,
      groupD: STATSIG_EXPERIMENTS_BUCKETS.GROUP_D,
    },
  },
  [STATSIG_EXPERIMENTS.NEW_CLP_FILTERS_MWEB]: {
    experimentName: 'new-clp-filters-mweb',
    defaultBucket: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
    buckets: {
      control: STATSIG_EXPERIMENTS_BUCKETS.CONTROL,
      groupA: STATSIG_EXPERIMENTS_BUCKETS.GROUP_A,
      groupB: STATSIG_EXPERIMENTS_BUCKETS.GROUP_B,
    },
  },
  [STATSIG_EXPERIMENTS.NEW_SEARCH_SUGGESTIONS]: {
    experimentName: 'new_search_suggestions',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.PERSONALISED_EXPLORE_EVERYTHING]: {
    experimentName: 'personalized-explore-everything',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.FEATURE_SECTION_2_DESIGN]: {
    experimentName: 'feature-section-2-design',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      groupA: 'groupA',
      groupB: 'groupB',
    },
  },
  [STATSIG_EXPERIMENTS.TRACKING_PAGE_CONTACT_US]: {
    experimentName: 'tracking-page-contact-us',
    defaultBucket: 'Control',
    buckets: {
      Control: 'Control',
      Experiment: 'Experiment',
    },
  },
  [STATSIG_EXPERIMENTS.CLP_PERSONALIZED]: {
    experimentName: 'clp-personalized',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.PERSONALIZED_BESTSELLER]: {
    experimentName: 'personalized_best_seller_v3',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.PDP_VIDEO]: {
    experimentName: 'pdp-video',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.OOS_CART]: {
    experimentName: 'out-of-stock-cart',
    defaultBucket: 'control',
    buckets: {
      control: 'Control',
      show: 'Show',
    },
  },
  [STATSIG_EXPERIMENTS.CART_CHECKOUT_CTA_BUTTON]: {
    experimentName: STATSIG_EXPERIMENTS.CART_CHECKOUT_CTA_BUTTON,
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      showA: 'ShowA',
      showB: 'ShowB',
    },
  },
  [STATSIG_EXPERIMENTS.RECOMMENDED_FOR_YOU_CAROUSEL]: {
    experimentName: 'recommended-for-you-carousel',
    defaultBucket: 'Control',
    buckets: {
      Control: 'Control',
      TestA: 'TestA',
      TestB: 'TestB',
    },
  },
  [STATSIG_EXPERIMENTS.PICKED_FOR_YOU_V1]: {
    experimentName: 'picked-for-you_v1',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.GET_WEBSITE_PRODUCTS_MIGRATION]: {
    experimentName: 'get-website-products-migration',
    defaultBucket: 'control',
    buckets: {
      control: 'control',
      show: 'show',
    },
  },
  [STATSIG_EXPERIMENTS.MOBILE_CART_PAGE_EXPERIMENT]: {
    experimentName: STATSIG_EXPERIMENTS.MOBILE_CART_PAGE_EXPERIMENT,
    defaultBucket: 'Control',
    buckets: {
      control: 'Control',
      showA: 'ShowA',
      showB: 'ShowB',
    },
  },
}
